// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderUploadStyles } from "@eisinc/Overrides/Components/OrderUpload";
import { css } from "styled-components";

orderUploadStyles.downloadTemplateButtonWrapper = {
    css: css`
        margin: 10px 0;
    `,
};

orderUploadStyles.downloadTemplateButton = {
    variant: "secondary",
};

orderUploadStyles.fileUploader = {
    buttonProps: {
        variant: "secondary",
        css: css`
            margin-top: 18px;
        `,
    },
};

orderUploadStyles.cancelUploadButton = {
    variant: "secondary",
    css: css`
        @media (max-width: 481px) {
            width: 100%;
            margin: 0;
        }
    `,
};

orderUploadStyles.uploadFileButtonWrapper = {
    css: css`
        margin: 10px 0;
        display: flex;
        flex-wrap: wrap;
    `,
};

orderUploadStyles.uploadFileButton = {
    css: css`
        margin-right: 10px;
        @media (max-width: 481px) {
            width: 100%;
            margin: 0;
            margin-bottom: 10px;
        }
    `,
};

orderUploadStyles.spinner = {
    color: "primary.main",
    size: 22,
    css: css`
        margin-right: 8px;
    `,
};
